import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { Translate } from "react-localize-redux";

interface MultilingualTestProps extends PageProps<{}> {
}

class MultilingualTest extends React.Component<MultilingualTestProps> {
    constructor(props: MultilingualTestProps) {
        super(props);
        bindAllOfThis(this, MultilingualTest.prototype);
    }

    render() {
        return (<div>
            <h2>Here's some title</h2>
            <Translate id="greeting"></Translate>
            <br />
            <Translate id="example.farewell"></Translate>
        </div>);
    }
}

export default MultilingualTest;



// WEBPACK FOOTER //
// ./src/pages/examples/MultilingualTest.tsx